var map = {
	"./bird.png": 4179,
	"./cafe.png": 6007,
	"./cat.png": 90,
	"./fire.png": 2779,
	"./forest.png": 8119,
	"./music.png": 4126,
	"./nighttime.png": 714,
	"./rainy.png": 4207,
	"./regular-fire.png": 7782,
	"./riverWave.png": 2858,
	"./strongwind.png": 4666,
	"./thunder-cloud.png": 7047,
	"./thunder.png": 1642,
	"./wave.png": 9674,
	"./wind-simple.png": 4623,
	"./windchime.png": 7418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;